module.exports = __webpack_public_path__ + "static/img/agendas_loading_48.f2b36336.gif";